import Vue from 'vue';

const state = {
    passCount: 0,
    phone: "",
    item: null,
    needCheckUserPhone: false,
};

const mutations = {
    changeRecoveryParams(state, items) {
        state = Object.assign(state, items)
    },
};

const getters = {
    getRecoveryPassCount: state => state.passCount,
    getRecoveryPhone: state => state.phone,
    getRecoveryItem: state => state.item,
    getRecoveryPhoneCheck: state => state.needCheckUserPhone,
};

const actions = {
    changeRecovery({commit}, items) {
        commit('changeRecoveryParams', items);
    },
    setRecoveryPassCount({commit}) {
        commit('createProcess', 'passCount');
        Vue.http.get(this.getters.getApiUrl + 'v1/access-recovery/pass').then(response => {
            let item = response.data;
            commit('changeRecoveryParams', {passCount: Number.parseInt(item.count)});
            commit('setProcessSuccess', 'passCount');
        }, response => {
            commit('changeRecoveryParams', {passCount: 0});
            commit('setProcessFailed', {id: 'passCount', message: response.body.message});
        });
    },
    setRecoveryPhone({commit}, phone) {
        commit('changeRecoveryParams', {phone: phone});
    },
    setRecoveryChoice({commit, getters}, choice_id) {
        commit('createProcess', 'recoveryChoice');
        let params = {
            contract_id: getters.getUserContractId,
            contract_number: getters.getUserContractTitle,
            choice_id: choice_id
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/access-recovery', params).then(response => {
            let item = response.data;
            commit('setProcessSuccess', 'recoveryChoice');
            commit('changeRecoveryParams', {item: item});
        }, response => {
            commit('setProcessFailed', {id: 'recoveryChoice', message: response.body.message});
        });
    },
    checkRecoveryCodePhone({commit}, code) {
        let params = {
            code: code,
        };
        commit('createProcess', 'checkRecoveryCodePhone');
        Vue.http.post(this.getters.getApiUrl + 'v1/access-recovery/check-code', params).then(response => {
            commit('setProcessSuccess', 'checkRecoveryCodePhone');
            commit('changeRecoveryParams', {needCheckUserPhone: false});
            commit('changeUserParams', {phoneDialogVisible: false});
        }, response => {
            commit('setProcessFailed', {id: 'checkRecoveryCodePhone', message: response.body.message});
        });
    },
    addRecoveryCodePhone({commit}, phone) {
        let params = {
            phone: phone,
        };
        commit('createProcess', 'addRecoveryCodePhone');
        Vue.http.post(this.getters.getApiUrl + 'v1/access-recovery/add-code', params).then(response => {
            commit('setProcessSuccess', 'addRecoveryCodePhone');
        }, response => {
            commit('setProcessFailed', {id: 'addRecoveryCodePhone', message: response.body.message});
        });
    },
    needRecoveryCheckUserPhone({commit}) {
        commit('createProcess', 'needRecoveryCheckUserPhone');
        Vue.http.get(this.getters.getApiUrl + 'v1/access-recovery/need-check-phone').then(response => {
            commit('setProcessSuccess', 'needRecoveryCheckUserPhone');
            commit('changeRecoveryParams', {needCheckUserPhone: 1 === response.data.need_check});
        }, response => {
            commit('setProcessFailed', {id: 'needRecoveryCheckUserPhone', message: response.body.message});
        });
    },
};

export default {
    state,
    mutations,
    getters,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/recovery.js